import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radio-selected--sprite",
  "use": "radio-selected--sprite-usage",
  "viewBox": "0 0 15.75 15.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.75 15.75\" id=\"radio-selected--sprite\">\n  <g fill=\"none\" transform=\"translate(-4.5,-4.5)\">\n    <rect width=\"14.75\" height=\"14.75\" x=\"5\" y=\"5\" fill=\"#F45334\" stroke=\"#F45334\" rx=\"7.375\" />\n    <path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M8.25 11.86l3.532 3.187 4.584-5.297\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol